import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import appStore from '@/store/app';
import erpStore from '@/store/erp';
import { ProductInOrder, TypeOfSearch } from '@/types';
import CardComponent from '@/components/CardComponent';
import ListToolbar from '@/components/ListToolbar';
import ColumnStatusProductOrders from '@/components/ColumnStatusProductOrders';
import { debounce } from '@/core/debounce';

@Component({
  components: { CardComponent, ListToolbar, ColumnStatusProductOrders },
})
export default class ErpProductsInOrders extends Vue {

  @Prop({ default: true }) private readonly checkable!: boolean;

  private selected: ProductInOrder | null = null;
  private keyword = '';
  private searchType: TypeOfSearch = TypeOfSearch.StartsWith;
  private searchAll = false;
  private pageSize = appStore.pageSize;
  private pageNumber = 1;

  private readonly minLength = 3;

  private debouncedFetchProductsInOrdersAsync = async (): Promise<void> => undefined;

  get loading(): boolean {
    return appStore.isLoading;
  }

  get products(): ProductInOrder[] {
    return erpStore.productInOrders;
  }

  get total(): number {
    const xxx = erpStore.totalProductInOrders;
    return erpStore.totalProductInOrders;
  }

  private async created() {
    this.debouncedFetchProductsInOrdersAsync = debounce(this.fetchProductsInOrdersAsync, 600);
    await this.fetchProductsInOrdersAsync();
  }

  private async mounted() {
    await appStore.activateMenuById({ rootId: 300, subMenuId: 302 });
  }

  @Watch('keyword', { immediate: false, deep: false })
  private async onKeywordChanged(value: string, previousValue?: string) {

    if (previousValue === undefined) return;
    if (value.trim() === '' || value.trim().length >= this.minLength) {
      this.pageNumber = 1;
      await this.debouncedFetchProductsInOrdersAsync();
    }
  }

  @Watch('searchAll', { immediate: false, deep: false })
  private async onHistoricalChanged(value: boolean, previousValue?: boolean) {

    if (previousValue === undefined) return;

    this.pageNumber = 1;
    this.searchAll = value;
    await this.debouncedFetchProductsInOrdersAsync();
  }

  @Watch('searchType', { immediate: false, deep: false })
  private async onSearchTypeChanged(value: TypeOfSearch, previousValue?: TypeOfSearch) {

    if (previousValue === undefined) return;

    this.pageNumber = 1;
    this.searchType = value;
    await this.debouncedFetchProductsInOrdersAsync();
  }

  private async onPageChange(page: number) {
    this.pageNumber = page;
    await this.fetchProductsInOrdersAsync();
  }

  private async reload() {
    await this.onPageChange(1);
  }

  private print() {
    if (!this.select) { return; }
    return;
  }

  private select(row: ProductInOrder, oldRow: ProductInOrder | null): void {
    this.selected = row;
  }

  private async fetchProductsInOrdersAsync() {
    await erpStore.fetchProductsInOrdersAsync({ keyword: this.keyword, searchType: this.searchType, searchAll: this.searchAll, page: this.pageNumber, size: this.pageSize });
  }

  private rowStyle(product: ProductInOrder, index: number): string {

    if (!product) { return ''; }

    if (product.annu) {
      if (product.annu === 'A' || product.annu === 'X') {
        return 'is-warning';
      }
    }


    if (product.status && product.status > 70) {
      return 'is-information';
    }

    return '';
  }
}